module.exports = __webpack_public_path__ + "static/media/Theatre.2f78d867.png";